/* istanbul ignore file */
export default
`<div class="template-not-found">
    <div class="alert alert-danger e-block e-outline">
        The template file for the layout was not found. Please contact your administrator.
    </div>
</div>`;
